import { useLazyQuery } from "@apollo/client";
import React, { useContext, useEffect, useMemo, useState } from "react";
// import { PEOPLE_FOR_LINK__PERSON_FRAGMENT } from "../../../features/graphql/query/person/fragments/peopleForLink__person";
// import { PERSON_FOR_LINK_QUERY } from "../../../features/graphql/query/person/getPersonForLink";
import { FragmentType, getFragmentData, gql } from "../../__generated__";
import { SELECTED_PERSON_FRAGMENT } from "../../features/graphql/query/person/fragments/peopleFragments";
import { PeopleForLink__PersonFragment } from "../../__generated__/graphql";
import { SelectedPerson_PersonFragment } from "../../__generated__/graphql";
export const SELECTED_PERSON_QUERY = gql(`
    query SelectedPerson($id:UUID!){
    person(id:$id){
        ...SelectedPerson_Person    
    }}`)


export type SelectedPersonFragment = FragmentType<typeof SELECTED_PERSON_FRAGMENT>;
// export type PersonDataType = Partial<SelectedPerson_PersonFragment> | null;

export type PersonDataType = PeopleForLink__PersonFragment | null;

export interface SelectedPersonContextType {
    person: PersonDataType,
    setSelectedPerson: (person: PersonDataType) => void,
}

export const SelectedPersonContext = React.createContext<SelectedPersonContextType | null>(null);

SelectedPersonContext.displayName = "SelectedPersonContext";


export interface SelectedPersonProviderProps {
    children: React.ReactNode
}

export const SelectedPersonProvider = ({ children }: SelectedPersonProviderProps) => {
    const [person, setSelectedPerson] = useState<PersonDataType>(null);

    const memorizedValue = useMemo(() => ({
        person, setSelectedPerson
    }), [person, setSelectedPerson]);

    return (
        <SelectedPersonContext.Provider value={memorizedValue}>
            {children}
        </SelectedPersonContext.Provider>
    )
}

export const useSelectPersonContext = () => {
    const context = useContext(SelectedPersonContext);

    if (!context)
        throw new Error('Call made outside provider. You must use useSelectPersonContext within the SelectedPersonProvider provider.');



    return context;
}

interface SelectedPerson {
    loading: boolean,
    person: PersonDataType,
    setSelectedPerson: (person: PersonDataType | null) => void,
    fetchSelectedPerson: (id: string) => void
}

export const useSelectedPerson = (id?: string | null): SelectedPerson => {
    const { person, setSelectedPerson } = useSelectPersonContext();
    const [fetch, { data, loading }] = useLazyQuery(SELECTED_PERSON_QUERY, {
        notifyOnNetworkStatusChange: true
    });

    const fetchSelectedPerson = (id: string) => {
        fetch({
            variables: {
                id
            }
        })
    }

    useEffect(() => {
        if (!id || person) return;
        fetchSelectedPerson(id);
    }, [id, person]);

    useEffect(() => {
        if (loading || !data) return;
        const fragment = getFragmentData(SELECTED_PERSON_FRAGMENT, data.person as FragmentType<typeof SELECTED_PERSON_FRAGMENT>);
        setSelectedPerson(fragment as PersonDataType);
    }, [loading, data]);


    return { loading, person, setSelectedPerson, fetchSelectedPerson };
}